import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import { StyledTableCell, StyledTableRow } from "../../../components";

const style = {
  fontSize: 14,
  color: theme.colors.black,
};

interface Props {
  data?: any;
}

const items = [
  {
    role: "creer_un_grouilleur",
    administrateur: true,
    manager: true,
    financier: true,
    operationnel: true,
  },
  {
    role: "creer_offre",
    administrateur: true,
    manager: false,
    financier: true,
    operationnel: true,
  },
  {
    role: "creer_boss",
    administrateur: true,
    manager: true,
    financier: false,
    operationnel: false,
  },
  {
    role: "valider_transaction",
    administrateur: true,
    manager: true,
    financier: true,
    operationnel: false,
  },
  {
    role: "annuler_transaction",
    administrateur: true,
    manager: true,
    financier: true,
    operationnel: true,
  },
  {
    role: "attribuer_tache",
    administrateur: true,
    manager: true,
    financier: true,
    operationnel: true,
  },
  {
    role: "mise_relation",
    administrateur: true,
    manager: true,
    financier: true,
    operationnel: true,
  },
];

function RoleTable({ data }: Props) {
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  // const handleChangePage = (event: any, newPage: any) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event: any) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: "#fff" }}>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("role"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("administrateur"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("manager"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("financier"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("operationnel"))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell>{i18n.t(item.role)}</StyledTableCell>
              <StyledTableCell
                style={{ color: item.administrateur ? "#00833D" : "#3D423F" }}
              >
                {i18n.t(item.administrateur ? "oui" : "non")}
              </StyledTableCell>
              <StyledTableCell
                style={{ color: item.manager ? "#00833D" : "#3D423F" }}
              >
                {i18n.t(item.manager ? "oui" : "non")}
              </StyledTableCell>
              <StyledTableCell
                style={{ color: item.financier ? "#00833D" : "#3D423F" }}
              >
                {i18n.t(item.financier ? "oui" : "non")}
              </StyledTableCell>
              <StyledTableCell
                style={{ color: item.operationnel ? "#00833D" : "#3D423F" }}
              >
                {i18n.t(item.operationnel ? "oui" : "non")}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RoleTable;
